<template>
  <div class="contract-information-page pb60" v-if="formData" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="付款通知单审批详情"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box">
      <div class="contract-apply-box mt15">
        <div class="contract-apply-item"><span>企业名称：</span>{{ formData.tenantName }}</div>
        <div class="contract-apply-item" v-if="formData.organisationName"><span>组织名称：</span>{{ formData.organisationName }}</div>
        <div class="contract-apply-item">
          <span>关联运营报告流程：</span
          ><span class="fontC-4fa1a4 c-pointer" @click="operationDialogVisible = true">查看</span>
        </div>
        <!-- <div class="contract-apply-item"><span>备注说明：</span>{{ formData.remarks }}</div> -->
      </div>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>申请盖章：</span>{{ formData.isApplyStamp == 'Y' ? '是' : '否' }}</div>
        <div class="contract-apply-item" v-if="formData.isApplyStamp == 'Y'"><span>印章类型：</span>{{ formData.stampType == '1' ? '业务章' : '公章' }}</div>
        <div class="contract-apply-item"><span>是否需要验收单盖章：</span>{{ formData.isDisplayReceipt == 'Y' ? '是' : '否' }}</div>
        <div class="contract-apply-item"><span>是否邮寄：</span>{{ formData.isMail == 'Y' ? '是' : '否' }}</div>
      </div>
      <el-row :gutter="24" v-if="formData.isMail == 'Y'">
        <el-col :span="24">
          <span class="contract-base-title">邮寄地址：</span>
          <div class="contract-base-content">{{ formData.mailAddress || '-' }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <span class="contract-base-title">备注：</span>
          <div class="contract-base-content">
            <span style="color: red;">{{ formData.remarks }}</span><span>{{ formData.remarks ?'': '-' }}</span>
          </div>
        </el-col>
      </el-row>
      <div class="contract-apply-file">
        <span class="file-label">运营报告：</span>
        <div>
          <div v-for="(item, index) in formData.reportFile" :key="index" style="line-height: 30px">
            <div class="contract-file-inform" style="margin-bottom: 4px">
              <span> {{ item.fileName }}</span
              ><span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看</span>
              <span class="fontC-4fa1a4 c-pointer ml10" @click="onDownload(item, index)">下载</span>

            </div>
          </div>
        </div>
      </div>
      <div class="contract-apply-file">
        <span class="file-label">附件上传：</span>
        <div>
          <div v-for="(item, index) in formData.otherFile" :key="index" style="line-height: 30px">
            <div class="contract-file-inform" style="margin-bottom: 4px">
              <span> {{ item.fileName }}</span
              ><span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看</span>
              <span class="fontC-4fa1a4 c-pointer ml10" @click="onDownload(item, index)">下载</span>

            </div>
          </div>
        </div>
      </div>
      <img
        v-show="formData.approveVO && formData.approveVO.approveState !== 'N'"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
      <img  v-if="formData.isHedge=='Y'"  class="duichong-img" src="../../assets/images/ic_duichong.png" alt="" srcset="">
    </div>
    <!-- 需开票的信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票/收款信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <div class="contract-base-title"><span class="fontC-red">*</span>是否已开票：</div>
          <span class="contract-base-content" v-if="formData.isInvoiced=='Y'">是</span>
          <span class="contract-base-content" v-else>否</span>
        </el-col>
        <el-col :span="12" >
          <span class="contract-base-title" style="width:140px;">是否回款：</span>
          <span class="contract-base-content" v-if="formData.isReceivePayment=='Y'">是</span>
          <span class="contract-base-content" v-else>否</span>
        </el-col>
        <el-col :span="12" v-if="formData.isInvoiced == 'Y'&&formData.isReceivePayment != 'Y'&&formData.invoiceDataSource=='1'">
          <div class="contract-base-title"><span class="fontC-red">*</span>预开票流程：</div>
          <div class="invoicedFlex" v-if="formData.planInvoiceApplyList&&formData.planInvoiceApplyList.length">
              <span 
              v-for="item in formData.planInvoiceApplyList"
              :key="item.guid"
              :label="item.label"
              :value="item.guid"
              class="contract-base-content">{{ item.label}}</span>
          </div>
          <div class="invoicedFlex" v-else>
            -
          </div>
          
        </el-col>
        <el-col :span="12" v-if="formData.isInvoiced == 'Y'&&formData.isReceivePayment != 'Y'&&formData.invoiceDataSource=='2'">
          <div class="contract-base-title"><span class="fontC-red">*</span>上游票据信息：</div>
          <div class="invoicedFlex" v-if="invoiceInfoVOList && invoiceInfoVOList.length">
              <span v-for="(inv,i) in invoiceInfoVOList" :key="i" class="contract-base-content">{{ inv.label }}</span>
          </div>
          <div class="invoicedFlex" v-else>
            -
          </div>
        </el-col>
        <el-col :span="12" v-if="formData.isInvoiced == 'Y'&&formData.isReceivePayment != 'Y'&& formData.invoiceDataSource=='1'&&formData.planInvoiceApplyList&&formData.planInvoiceApplyList.length">
          <span class="contract-base-title" >小计：</span>
          <div class="contract-base-content" >
            <span>{{ getSumAmount(formData.planInvoiceApplyList,6)| numDigit }} 元</span>
          </div>
          
        </el-col>
        <el-col :span="12" v-if="formData.isInvoiced == 'N'">
          <div class="contract-base-title"><span class="fontC-red">*</span>开票申请：</div>
          <span class="contract-base-content" v-if="formData.isApplyInvoice=='Y'">是</span>
          <span class="contract-base-content" v-else>否</span>
        </el-col>
        
        <el-col :span="12" v-if="formData.isInvoiced != 'Y'&&formData.isReceivePayment == 'Y'">
          <span class="contract-base-title" style="width:140px;">关联上游收款：</span>
          <div class="contract-base-content" v-if="formData.receivePaymentList&&formData.receivePaymentList.length">
            <div class="receive-payment" v-for="(item, index) in formData.receivePaymentList" :key="index">
              {{ item.receiveDate }}收款<span style="color:#ff5f1f;">{{ item.receiveAmount | numDigit }}</span>元
            </div>
          </div>
          <div class="contract-base-content" v-else>
            -
          </div>
        </el-col>
        <el-col :span="12" v-if="formData.isInvoiced != 'Y'&&formData.isReceivePayment == 'Y'&&formData.receivePaymentList&&formData.receivePaymentList.length"></el-col>
        <el-col :span="12" v-if="formData.isInvoiced != 'Y'&&formData.isReceivePayment == 'Y'&&formData.receivePaymentList&&formData.receivePaymentList.length">
          <span class="contract-base-title" >小计：</span>
          <div class="contract-base-content" >
            <span>{{ getSumAmount(formData.receivePaymentList,5)| numDigit }} 元</span>
          </div>
          
        </el-col>
      </el-row>
      <div 
        v-if="formData.isInvoiced == 'Y'&&formData.isReceivePayment == 'Y'">
        <div v-for="(item, index) in formData.planInvoiceReceivePaymentList" :key="index" >
          <el-row :gutter="24" >
            <el-col :span="12" v-if="item.invoiceDataSource=='1'&&item.planInvoiceApplyList&&item.planInvoiceApplyList.length>0">
              <div class="contract-base-title"><span class="fontC-red">*</span>预开票流程：</div>
              <div class="invoicedFlex">
                  <span 
                  v-for="obj1 in item.planInvoiceApplyList"
                  :key="obj1.guid"
                  :label="obj1.name"
                  :value="obj1.guid"
                  class="contract-base-content">{{ obj1.name}}</span>
              </div>
            </el-col>
            <el-col :span="12" v-if="item.invoiceDataSource=='2'&&(item.invoiceInfoList&&item.invoiceInfoList.length||item.invoiceInfo)">
              <div class="contract-base-title"><span class="fontC-red">*</span>上游票据信息：</div>
              <div class="invoicedFlex">
                  <span
                  v-for="obj in (item.invoiceInfoList&&item.invoiceInfoList.length?item.invoiceInfoList:(item.invoiceInfo?[item.invoiceInfo]:[]))"
                  :key="obj.guid"
                  class="contract-base-content">{{ obj.name}}</span>
              </div>
            </el-col>
            <el-col :span="12" >
              
              <div class="contract-base-title" style="width:140px;">关联上游收款：</div>
              <div class="invoicedFlex">
                  <span 
                  v-for="obj2 in item.receivePaymentList"
                  :key="obj2.guid"
                  :label="obj2.name"
                  :value="obj2.guid"
                  class="contract-base-content">{{ obj2.name}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24" class="sum-row">
            <el-col :span="12" >
              <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
              <span v-show="item.invoiceDataSource == '1'">{{ getSumAmount(item.planInvoiceApplyList,1)| numDigit }} 元</span>
              <span v-show="item.invoiceDataSource == '2'">{{ getSumAmount(item,7)| numDigit }} 元</span>
            </el-col>
            <el-col :span="12">
              <div class="contract-base-title"><span class="fontC-red"></span>小计：</div>
              <span>{{ getSumAmount(item.receivePaymentList,2)| numDigit }} 元</span>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="24" class="sum-row">
          <el-col :span="12" >
            <div class="contract-base-title"><span class="fontC-red"></span>合计：</div>
            <span style="color: rgb(255, 95, 31);">{{ getSumAmount(formData.planInvoiceReceivePaymentList,3)| numDigit }}</span>&nbsp;元
          </el-col>
          <el-col :span="12">
            <div class="contract-base-title"><span class="fontC-red"></span>合计：</div>
            <span style="color: rgb(255, 95, 31);">{{ getSumAmount(formData.planInvoiceReceivePaymentList,4)| numDigit }}</span>&nbsp;元
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 开票说明 -->
    <div class="contract-base-box" v-if="formData.isApplyInvoice == 'Y'">
      <p class="contract-base-name">开票说明</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">开票金额：</span>
          <div class="contract-base-content">
            <div> {{ invoiceApplyVO.invoiceAmount | numDigit }} 元</div>
            <div>{{ invoiceApplyVO.invoiceAmount | upDigit }}</div>
          </div>
          <!-- <span class="contract-base-title">大写：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.invoiceAmount | upDigit }}</div> -->
        </el-col>
     
        <el-col :span="12">
          <span class="contract-base-title">开票主体：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.servicerTenantName || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开票日期：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.invoiceDate || '-' }}</div>
        </el-col>
     
        <el-col :span="12">
          <span class="contract-base-title">发票类型：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.invoiceOptions | commonFilterName('发票选项') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">企业名称：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.tenantName }}</div>
        </el-col>
        <el-col :span="12" v-if="invoiceApplyVO.organisationName">
          <span class="contract-base-title">组织名称：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.organisationName }}</div>
        </el-col>
        <!-- <el-col :span="12">
          <span class="contract-base-title">发票类目：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.invoiceCategory | commonFilterName('发票类目') }}</div>
        </el-col> -->
        <el-col :span="12">
          <span class="contract-base-title">预计回款日期：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.planRepayDate | getDate }}</div>
        </el-col>
        <!-- <el-col :span="12" v-if="invoiceApplyVO.isReceivePayment == 'Y'">
          <span class="contract-base-title">关联上游收款：</span>
          <div class="contract-base-content" v-if="invoiceApplyVO.receivePaymentList&&invoiceApplyVO.receivePaymentList.length">
            <div class="receive-payment" v-for="(item, index) in invoiceApplyVO.receivePaymentList" :key="index">
              {{ item.receiveDate }}收款<span style="color:#ff5f1f;">{{ item.receiveAmount | numDigit }}</span>元
            </div>

          </div>
          <div class="contract-base-content" v-else>
            -
          </div>
        </el-col> -->
        <el-col :span="28" style="display:flex;">
          <span class="contract-base-title" style="min-width:140px;text-align: right;">简述或备注：</span>
          <div class="contract-base-content">
            <span style="color: red;">{{ invoiceApplyVO.remarks }}</span><span>{{ invoiceApplyVO.remarks ?'': '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 开票信息 -->
    <div class="contract-base-box" v-if="formData.isApplyInvoice == 'Y'">
      <p class="contract-base-name">开票信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">发票抬头：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.invoiceTenantName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">合计金额(元)：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.invoiceAmount | numDigit }}</div>
        </el-col>
        <div v-for="(item, index) in invoiceApplyVO.invoiceApplyDetailList" :key="index">
            <el-col :span="12">
            <span class="contract-base-title">发票类目{{index+1}}：</span>
            <div class="contract-base-content">{{ item.invoiceCategory | commonFilterName('发票类目')}}</div>
          </el-col>
          <el-col :span="12">
            <span class="contract-base-title">金额(元)：</span>
            <div class="contract-base-content">{{ item.invoiceAmount | numDigit }}</div>
          </el-col>
        </div>
        <el-col :span="12">
          <span class="contract-base-title">开户银行：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.bankName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">电话号码：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.contactTel || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">税号：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.taxpayerId || '-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">银行账号：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.bankAccount || '-' }}</div>
        </el-col>

        <el-col :span="12">
          <span class="contract-base-title">单位地址：</span>
          <div class="contract-base-content">{{ invoiceApplyVO.address || '-' }}</div>
        </el-col>
      </el-row>
    </div>
    <!-- 财务信息（盖章附件/物流为单据级整单一份；票据信息按发票展示,仅开票单） -->
    <div class="contract-base-box" v-if="isShowFinanceInfo">
      <p class="contract-base-name">财务信息</p>
      <!-- 盖章附件（单据级，整单一份，不随发票重复显示；无关联发票的单也展示） -->
      <div class="contract-apply-file" style="margin-left:40px" v-if="formData.paymentAdviceAttach && formData.paymentAdviceAttach.length">
        <span class="file-label">盖章附件信息：</span>
        <div>
          <div v-for="(item, index) in formData.paymentAdviceAttach" :key="index" style="line-height: 30px">
            <div class="contract-file-inform" style="margin-bottom: 4px">
              <span> {{ item.fileName }}</span
              ><span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看</span>
              <span class="fontC-4fa1a4 c-pointer ml10" @click="onDownload(item, index)">下载</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 物流信息（单据级，整单一份，不随发票重复显示；无关联发票的单也展示；el-row顶格与开票信息区对齐,标签140px冒号线一致） -->
      <el-row :gutter="24" v-if="formData.isMail == 'Y'">
        <el-col :span="12" v-if="formData.expressNo">
          <span class="contract-base-title">快递单号：</span>
          <div class="contract-base-content">{{ formData.expressNo }}</div>
        </el-col>
        <el-col :span="12" v-if="formData.expressCompany">
          <span class="contract-base-title">快递公司：</span>
          <div class="contract-base-content">{{ formData.expressCompany }}</div>
        </el-col>
      </el-row>
      <!-- 票据信息按发票展示(仅开票单;不开票单无票据内容,不渲染空壳块;附件/日期/税率全一致时整合为一条,不显示"发票(N)"标题) -->
      <template v-if="formData.isApplyInvoice == 'Y'">
      <div v-for="(inv, i) in invoiceDisplayList" :key="i" style="border-bottom:1px dashed #eee;padding-bottom:8px;margin-bottom:8px">
        <p class="contract-base-name" v-if="invoiceDisplayList.length > 1">发票（{{ i + 1 }}）</p>
        <div class="contract-apply-file" style="margin-left:40px" v-if="formData.isApplyInvoice == 'Y' && inv.invoiceAttach && inv.invoiceAttach.length">
          <span class="file-label">票据附件信息：</span>
          <div>
            <div v-for="(item, index) in inv.invoiceAttach" :key="index" style="line-height: 30px">
              <div class="contract-file-inform" style="margin-bottom: 4px">
                <span> {{ item.fileName }}</span>
                <span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看</span>
                <span class="fontC-4fa1a4 c-pointer ml10" @click="onDownload(item, index)">下载</span>
              </div>
            </div>
          </div>
        </div>
        <el-row :gutter="24">
          <el-col :span="12" v-if="formData.isApplyInvoice == 'Y' && inv.invoiceDate">
            <span class="contract-base-title">开票日期：</span>
            <div class="contract-base-content">{{ inv.invoiceDate | getDate }}</div>
          </el-col>
          <el-col :span="12" v-if="formData.isApplyInvoice == 'Y' && inv.taxRate">
            <span class="contract-base-title">税率(%)：</span>
            <div class="contract-base-content">{{ inv.taxRate | numDigit }}</div>
          </el-col>
        </el-row>
      </div>
      </template>
    </div>
    <!-- 付款通知书 -->
    <div class="contract-base-box">
      <div style="max-width: 700px">
        <div class="contract-base-name">
          <span>{{ getTitleType(formData.tenantGuid) }}</span>
          <div>
            <el-button type="borderGreen" size="mini" @click="handleCombinePrint">合并打印</el-button>
            <el-button type="borderGreen" size="mini" @click="showPrint = true">打印</el-button>
          </div>
        </div>
        <div class="pay-box">
          <h2>{{ getTitleType(formData.tenantGuid) }}
            <div style="font-size:12px;font-weight: normal;">（账单周期：{{formData.accountMonthStartDate}}至{{formData.accountMonthEndDate}}）</div>
          </h2>
          <el-input v-model="billCycle" style="width: 200px;" placeholder="请输入账单周期" clearable></el-input>
          <p>致{{formData.tenantName}}：</p>
          <p>根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢。</p>
          <table border="1px" class="mb30 w100f">
            <tr>
              <td colspan="2" class="tBg tdCenter font-S18">本期应付款汇总结算明细</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期应付款合计金额（小写）：</td>
              <td class="t-right">{{ formData && formData.currentPayAmount | numDigit | numFmt }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期应付款合计（大写）：</td>
              <td class="t-right">{{ formData && formData.currentPayAmount | smallToBig }}</td>
            </tr>
          </table>
          <div class="back-color-fff content-main-box h100f" max-height="50vh">
            <el-table :data="tableData" stripe border style="width: 100%">
              <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="tenantName"
                label="任务类型"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="160"
                fixed="left"
              >
                <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="数量"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="80"
              >
                <template slot-scope="scope">{{ scope.row.taskTotal }}</template>
              </el-table-column>
              <el-table-column
                prop="planYear"
                label="单价"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="110"
              >
                  <template slot-scope="scope">{{ (scope.row.settlePercent ? '-' : scope.row.taskPrice) | numFmt | numDigit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="计价单位"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="80"
              >
                <template slot-scope="scope">{{ scope.row.settlePercent ? '-' : scope.row.taskPriceUnit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="金额(元)"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="110"
              >
                <template slot-scope="scope">{{ scope.row.taskAmount | numFmt | numDigit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="备注"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="140"
              >
                <template slot-scope="scope">{{ scope.row.settlePercent?'固定比例，按照上游流向数据比对结果':scope.row.note }}</template>
              </el-table-column>
            </el-table>
          </div>
          <table border="1px" class="table-total-money mb15 w100f">
            <tr>
              <td class="tdBg" width="212">合计任务金额(元)</td>
              <td class="t-right">{{ formData && formData.taskSumAmount | numFmt | numDigit }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="212">工业考核得分</td>
              <td class="t-right">{{ getPaymentComprehensiveGrade() }}</td>
            </tr>
            <tr v-show="formData && formData.isContainServiceFee !== 'Y'">
              <td class="tdBg" width="212">平台运营服务费(元)</td>
              <td class="t-right">{{ formData && formData.serviceFee | numFmt | numDigit }}</td>
            </tr>
            <tr v-show="formData && formData.reportCoefficient != null&&formData.isContainServiceFee!=='Y'">
              <td class="tdBg" width="212">数据服务费(元)</td>
              <td class="t-right">{{ formData && formData.dataServiceFee | numFmt | numDigit }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="212">本期应付金额(元)</td>
              <td class="t-right">{{ formData && formData.currentPayAmount | numFmt | numDigit }}</td>
            </tr>
          </table>
          <!-- <div class="total_money_wrap">
            <div class="total-money-list">
              <span class="total-money-title">合计任务金额</span
              ><span class="total-money-num">{{ formData && formData.taskSumAmount | numFmt | numDigit }}</span
              >元
            </div>
            <div class="total-money-list">
              <span class="total-money-title">工业考核得分</span
              ><span class="total-money-num">{{ formData && (formData.comprehensiveGrade * 100).toFixed(2) }}</span>
            </div>
            <div class="total-money-list" v-show="formData.isContainServiceFee !== 'Y'">
              <span class="total-money-title">平台运营服务费({{ formData && formData.serviceFeeRate }}%)</span
              ><span class="total-money-num">{{ formData && formData.serviceFee | numFmt | numDigit }}</span
              >元
            </div>
            <div class="total-money-list">
              <span class="total-money-title">本期应付金额</span
              ><span class="total-money-num">{{ formData && formData.currentPayAmount | numFmt | numDigit }}</span
              >元
            </div>
          </div> -->
          <p class="pay-title-txt mb15">支付账户信息如下：</p>
          <table border="1px" class="mb15 w100f">
            <tr>
              <td class="tdBg" width="170">开户名称：</td>
              <td class="t-left">{{ formData.serviceTenantName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">开户银行：</td>
              <td class="t-left">{{ formData && formData.bankName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">银行账号：</td>
              <td class="t-left">{{ formData && formData.bankAccount }}</td>
            </tr>
          </table>
          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
          <!-- <p class="pay-title-txt" style="justify-content: flex-end; padding-right: 100px">
            <span>盖章处</span>
          </p> -->
        </div>
      </div>
    </div>
    <!-- 推广计划确认单 -->
    <div class="contract-base-box" v-show="formData.isShowPromotionPlan=='Y'">
      <div v-if="promotionType==1" style="max-width: 700px">
        <p class="contract-base-name">
          <span>{{ promotionTitle }}</span>
          <el-button type="borderGreen" size="mini" @click="showPlanPrint = true">打印</el-button>
        </p>
        <div class="pay-box">
          <h2>{{ promotionTitle }}<div style="font-size:12px;font-weight: normal;">(执行日期：{{formData.accountMonthStartDate}}至{{formData.accountMonthEndDate}})</div></h2>
          <p>致{{formData.tenantName}}：</p>
          <p>根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下推广计划，谢谢。</p>
          <div style="display: flex;justify-content: space-between">
            <p>委托方：{{formData.tenantName}}</p>
            <p>服务方：{{formData.serviceTenantName}}</p>
          </div>
          <div style="display: flex;justify-content: flex-start">
            <div >任务标题：</div>
            <div>
              <div style="margin-bottom:10px;text-align: left;" v-for="item in formData.taskInfoList">
                {{ item.name ||'-' }}
                <span class="fontC-4fa1a4 c-pointer ml10" @click="seeDetail(item)">查看详情</span>
              </div>
            </div>
          </div>
          
          <div class="back-color-fff content-main-box h100f" max-height="50vh">
            <el-table :data="planData" stripe border style="width: 100%;margin-bottom: 20px;">
              <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taskContentName"
                label="任务类型"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="80"
                fixed="left"
              >
                <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="数量"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="80"
              >
              <template slot-scope="scope">
                <div v-if="scope.row.taskTotalType!='固定量人均'&&scope.row.taskTotalType!='不限量'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskTotal }}</div>
                  <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                </div>
                <div v-if="scope.row.taskTotalType=='固定量人均'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskAvg }}</div>
                  <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                </div>
                <div v-if="scope.row.taskTotalType=='不限量'" style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>不限量</div>
                </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="planYear"
                label="价格"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="100"
              >
              <template slot-scope="scope">{{ scope.row.tenantTaskPrice }} {{ scope.row.tenantTaskPriceUnit }}</template>
                  <!-- <template slot-scope="scope">{{ (scope.row.settlePercent ? '-' : scope.row.taskPrice) | numFmt | numDigit }}</template> -->
              </el-table-column>
              <el-table-column
                prop="tenantTaskNote"
                label="任务描述"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="180"
              >
              <template slot-scope="scope">{{ getTenantTaskNote(scope.row) }}</template>
              </el-table-column>
              
              
            </el-table>
          </div>
          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
          <!-- <p class="pay-title-txt" style="justify-content: flex-end; padding-right: 100px">
            <span>盖章处</span>
          </p> -->
        </div>
      </div>
      <div v-if="promotionType==2" style="max-width: 700px">
        <p class="contract-base-name">
          <span>{{ promotionTitle }}</span>
          <el-button type="borderGreen" size="mini" @click="showItemPrint = true">打印</el-button>
        </p>
        <div class="pay-box">
          <h2>{{ promotionTitle }}<div style="font-size:12px;font-weight: normal;">（账单周期：{{formData.accountMonthStartDate}}至{{formData.accountMonthEndDate}})</div></h2>
          <p>致{{formData.tenantName}}：</p>
          <p>根据贵公司与我公司所签订的相关服务协议，请贵公司确认以下预算费用明细，谢谢。</p>
          <table border="1px" class="mb30 w100f">
            <tr>
              <td colspan="2" class="tBg tdCenter font-S18">本期预付款汇总结算明细</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期预付款合计金额（小写）：</td>
              <td class="t-right">{{ getSumAmount(planData,8) | numDigit | numFmt }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="270">本期预付款合计（大写）：</td>
              <td class="t-right">{{ getSumAmount(planData,8) | smallToBig }}</td>
            </tr>
          </table>
          <div class="back-color-fff content-main-box h100f">
            <el-table :data="planData" stripe border style="width: 100%" max-height="50vh">
              <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="taskContentName"
                label="任务类型"
                show-overflow-tooltip
                header-align="center"
                align="left"
                min-width="160"
                fixed="left"
              >
                <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="数量"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="80"
              >
              <template slot-scope="scope">
                <div v-if="scope.row.taskTotalType!='不限量'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskTotal }}</div>
                  <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                </div>
                <!-- <div v-if="scope.row.taskTotalType=='固定量人均'"  style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>{{ scope.row.taskAvg }}</div>
                  <span style="margin-left: 4px">{{ scope.row.taskTotalUnit }}</span>
                </div> -->
                <div v-if="scope.row.taskTotalType=='不限量'" style="display: flex; align-items: center;text-align: right;justify-content: flex-end">
                  <div>不限量</div>
                </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="planYear"
                label="单价"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="110"
              >
                <template slot-scope="scope">{{ scope.row.tenantTaskPrice | numFmt | numDigit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="计价单位"
                show-overflow-tooltip
                header-align="center"
                align="left"
                width="80"
              >
              <template slot-scope="scope">{{ scope.row.tenantTaskPriceUnit }}</template>
              </el-table-column>
              <el-table-column
                prop="planName"
                label="金额(元)"
                show-overflow-tooltip
                header-align="center"
                align="right"
                width="110"
              >
                <template slot-scope="scope">{{ scope.row.taskAmount | numFmt | numDigit }}</template>
              </el-table-column>
            </el-table>
          </div>
          <table border="1px" class="table-total-money mb15 w100f">
            <tr>
              <td class="tdBg" width="212">合计任务金额(元)</td>
              <td class="t-right">{{ getSumAmount(planData,8) | numFmt | numDigit }}</td>
            </tr>
          </table>
          <p class="pay-title-txt mb15">支付账户信息如下：</p>
          <table border="1px" class="mb15 w100f">
            <tr>
              <td class="tdBg" width="170">开户名称：</td>
              <td class="t-left">{{ formData.serviceTenantName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">开户银行：</td>
              <td class="t-left">{{ formData && formData.bankName }}</td>
            </tr>
            <tr>
              <td class="tdBg" width="170">银行账号：</td>
              <td class="t-left">{{ formData && formData.bankAccount }}</td>
            </tr>
          </table>
          <div class="page-write">
            <div>申请单位（盖章）：</div>
            <div>审核单位（盖章）：</div>
          </div>
        </div>
      </div>
    </div>
    <div class="contract-base-box" v-show="formData.isDisplayReceipt == 'Y'">
      <ExcelFile :data="formData" :tableData="planData" showPrint/>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap" v-if="formData">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit"
        >重新提交</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看关联的运营报告流程" :visible.sync="operationDialogVisible" width="900px" top="15%">
      <div class="back-color-fff content-main-box h100f">
        <el-table :data="operationTableData" stripe border style="width: 100%" height="60vh">
          <el-table-column label="序号" width="50" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="flowName"
            label="流程名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.flowName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="发起人"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="90"
          >
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizTenantName"
            label="企业名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="160"
          >
            <template slot-scope="scope">{{ scope.row.bizTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizOrganisationName"
            label="组织名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.bizOrganisationName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="taskTitleName"
            label="任务包名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.taskTitleName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="accountMonthName"
            label="核算月"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="90"
          >
            <template slot-scope="scope">{{ scope.row.accountMonthName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="currentPayAmount"
            label="应付金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="140"
          >
            <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="comprehensiveGrade"
            label="分值"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="70"
          >
            <template slot-scope="scope">{{ getComprehensiveGrade(scope.row) }}</template>
          </el-table-column>
          <el-table-column  width="100" label="操作" fixed="right" header-align="center" align="center">
            <template slot-scope="scope"><span class="txt-color" @click="toOperationDetail(scope.row)">详情</span></template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <printDialogCheck
      v-if="showPrint"
      :showPrintDialog.sync="showPrint"
      :printData="formData"
      :printTitle="getTitleType(formData.tenantGuid)"
      :billCycle="billCycle"
      @closePrint="showPrint = false"
      :printType="2"
      :currentTenantName="currentTenantName"
    ></printDialogCheck>
    <!-- <PassDialog :flowType="flowType" @passSuccess="$router.go(-1)" ref="pass"></PassDialog> -->
    <InvoiceInfoDialog
      :flowType="flowType"
      @passSuccess="$router.go(-1)"
      ref="invoiceInfoDialogRef"
    ></InvoiceInfoDialog>
    <StampAttachmentDialog
      :flowType="flowType"
      @passSuccess="$router.go(-1)"
      ref="stampAttachmentDialogRef"
    ></StampAttachmentDialog>
    <printPlanDialog
      v-if="showPlanPrint"
      :showPrintDialog.sync="showPlanPrint"
      :printData="formData"
      :planData="planData"
      @closePrint="showPlanPrint = false"
      :printType="2"
      :currentTenantName="currentTenantName"
    ></printPlanDialog>
    <printItemDialog
      v-if="showItemPrint"
      :showPrintDialog.sync="showItemPrint"
      :printTitle="promotionTitle"
      :printData="formData"
      :planData="planData"
      :billCycle="billCycle"
      @closePrint="showItemPrint = false"
      :printType="2"
      :currentTenantName="currentTenantName"
    ></printItemDialog>
    <printCombine
      v-if="showCombinePrint"
      :showPrintDialog.sync="showCombinePrint"
      :printData="formData"
      :planData="planData"
      :paymentTitle="getTitleType(formData.tenantGuid)"
      :promotionTitle="promotionTitle"
      :promotionType="promotionType"
      :showPaymentNotice="true"
      :showPromotionPlan="formData.isShowPromotionPlan == 'Y' && planData && planData.length > 0"
      :showReceipt="formData.isDisplayReceipt == 'Y'"
      :billCycle="billCycle"
      @closePrint="showCombinePrint = false"
    ></printCombine>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
// import PassDialog from './components/passDialog.vue';
import InvoiceInfoDialog from "./components/InvoiceInfoDialog.vue";
import StampAttachmentDialog from "./components/StampAttachmentDialog.vue";
import printDialogCheck from './components/printCost.vue';
import printPlanDialog from './components/printPlan.vue';
import printItemDialog from './components/printItem.vue';
import printCombine from './components/printCombine.vue';
import ExcelFile from './components/excelFile.vue'
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
import Decimal from "decimal.js"

export default {
  components: {
    Title,
    // PassDialog,
    InvoiceInfoDialog,
    StampAttachmentDialog,
    printDialogCheck,
    printPlanDialog,
    printItemDialog,
    printCombine,
    ExcelFile
  },
  mixins:[getTenantDetail],
  data() {
    return {
      flowType: '00017',
      rejectDialogVisible: false,
      passDialogVisible: false,
      operationDialogVisible: false,
      fullscreenLoading: false,
      approveSuggest: '',
      approveGuid: null, //审批ID
      formData: null,
      planData:null,
      tableData: [],
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: true,
      currentStaffGuid: null, //当前登录人guid
      payTypeJsonList: [],
      fileList: [],
      invoiceInfoVO: {},
      invoiceInfoVOList: [],
      invoiceApplyVO: null,
      showPrint: false,
      showPlanPrint: false,
      showItemPrint: false,
      showCombinePrint: false,
      currentTenantName: null,
      operationTableData: [],
      currentTenantBankData: null,
      advanceInvoicingTableData: [], //预开票数据
      billCycle:'',//付款通知书下面的账单周期
      bizList:[],//业务参数配置的列表
      promotionType:1,//1推广计划确认单 2服务项目预算确认单
      promotionTitle:'推广计划确认单',//1推广计划确认单 2服务项目预算确认单
      isLastNode: false,//是否是最后一个节点
    };
  },
  async created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userInfo.staffGuid;
    this.currentTenantName = userInfo.tenantName;
    await this.Mixins_getServiceProviderType();
    await this.getLastNode();
    this.getPageDetail();
    this.getPlanDetail();
    this.getBpmnUrl();
  },
  
  methods: {
    // 付款通知书工业考核得分（需要乘以100）
    getPaymentComprehensiveGrade() {
      if (!this.formData || this.formData.comprehensiveGrade === null || this.formData.comprehensiveGrade === undefined) {
        return '-';
      }
      const score = Number(this.formData.comprehensiveGrade) * 100;
       // 保留两位小数 向上取整
      if (this.formData.scoreRule == 1) {
        return this.ceilToTwoDecimals(score);
      }
      // 原有逻辑 四舍五入
      return score.toFixed(2);
    },
    // 关联运营报告列表分值
    getComprehensiveGrade(item) {
      if (!item || item.comprehensiveGrade === null || item.comprehensiveGrade === undefined) {
        return '-';
      }
      if (item.scoreRule == 1) {
        return this.ceilToTwoDecimals(item.comprehensiveGrade);
      }
      return Number(item.comprehensiveGrade).toFixed(2);
    },
    // 保留两位小数 向上进一
    ceilToTwoDecimals(num) {
      // 产品想要的效果是保留两位小数 必须向上进一
      // 比如 6.000000 向上取整应该是 是 6.00, 但是产品需要 6.01
      // 6.000001 向上取整 6.01
      // 6.000009 向上取整是 6.01
      // 6.010000 向上取整是 6.01 产品需要 6.02
      // 如果floorToTwoDecimals大于等于100，不需要加0.01
      
      // 取整后加 0.01
      const value = new Decimal(num);
      const floorToTwoDecimals = value.times(100).floor().dividedBy(100);
      if (floorToTwoDecimals.greaterThanOrEqualTo(100)) {
        return floorToTwoDecimals.toFixed(2);
      }
      return floorToTwoDecimals.plus(0.01).toFixed(2);
    },
    getTypeBizList() {
      let that = this;
      let guid = that.formData.tenantGuid
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${guid}&code=PAYMENT_TICKET_PLAN`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let bizList = resp.data.data;
            this.promotionType=1
            this.promotionTitle='推广计划确认单'
            const obj = bizList.find(item => item.tenantGuid === guid);
            if (obj) {
              this.promotionType=2//1推广计划确认单 2服务项目预算确认单
              this.promotionTitle = obj.name;
            }
            this.$forceUpdate();
          } else {
            that.$message.error(resp.data.msg);
          }
        });
    },
    getTitleType(guid){
      let title='付款通知书'
      const obj = this.bizList.find(item => item.tenantGuid === guid);
      if (obj) {
          title = obj.name;
      }
      return title
    },
    getTitleBizList() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${that.formData.tenantGuid}&code=PAYMENT_TICKET_TITLE`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.bizList = resp.data.data;
            this.$forceUpdate();
          } else {
            that.$message.error(resp.data.msg);
          }
        });
    },

    getSumAmount(list, type) {
      let sum = 0;
      console.log('list',list,type);
      // return
      if (type == 1) {
        list.forEach((item) => {
          sum += Math.round(item.desc * 100) / 100 ;
        });
      }
      if (type == 2) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          sum += Math.round(item.desc * 100) / 100 ;
        });
      }
      if (type == 3) {
        list.forEach((item) => {
          if(item.invoiceDataSource=='1'&&item.planInvoiceApplyList.length>0){
            item.planInvoiceApplyList.forEach(item2=>{
              sum += Math.round(item2.desc * 100) / 100 ;
            })
            
          }
          if(item.invoiceDataSource=='2'){
            (item.invoiceInfoList||[]).forEach(ic => {
              sum += Math.round(ic.desc * 100) / 100 ;
            })
          }
          
        });
      }
      if (type == 4) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          if(item.receivePaymentList.length>0){
            item.receivePaymentList.forEach(item2=>{
              sum += Math.round(item2.desc * 100) / 100 ;
            })
          }
          
          
        });
      }
      if (type == 5) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          
              sum += Math.round(item.receiveAmount * 100) / 100 ;
            
          
        });
      }
      if (type == 6) {
        // isApplyInvoiceTableData
        list.forEach((item) => {
          
              sum += Math.round(item.invoiceAccount * 100) / 100 ;
            
          
        });
      }
      if (type == 7) {
        console.log('777',list);
        if(list.invoiceDataSource=='2'&&list.invoiceInfoList){
          list.invoiceInfoList.forEach(ic => {
            sum += Math.round(ic.desc * 100) / 100 ;
          })
        }
      }
      if (type == 8) {
        if(!list||list.length<1)return
        list.forEach((item) => {
          sum += Math.round(item.taskAmount * 100) / 100 ;
        });
      }
      
      return sum;
    },
    
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.approveVO && this.formData.approveVO.approveState);
    },
    //查看附件
    toSee(file, index) {
      var fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(file.path, file.fileName);
      }
      if (fileSuffix == 'zip' || fileSuffix == 'rar'||fileSuffix == 'tar') {
        return window.open(file.path + '?response-content-type=application/octet-stream');
      }
      if (fileSuffix=='ofd') {
        return window.open("https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)); 
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    seeDetail(item) {
      let self = this;
                   
          this.$router.push({
              path: '/taskDeliverDetail?guid=' + item.guid,
              query: {
                  flag:1,
              }
          })
                
       
        },
    //获取操作按钮显隐
    getBtnState(btnType) {
      let approveVO = this.formData && this.formData.approveVO;
      return workFlowCommon.getBtnState(
        btnType,
        approveVO.approveState,
        approveVO.approveStaffGuids,
        this.currentStaffGuid,
        approveVO.staffGuid,
        this.formData.bizApproveState,
      );
    },
    //合并打印
    handleCombinePrint() {
      this.showCombinePrint = true;
    },
    // 任务描述
    getTenantTaskNote(detail) {
      if (detail.taskTotalType == '固定量人均') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      } else if (detail.taskTotalType == '系统计算') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      }
    },
    // 是否是倒数第二节点（财务票据上传节点）
    async isSecondLastNode() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        staffGuid: userinfo.staffGuid,
        deploymentId: this.$route.query.camundaDeploymentId,
        processInstanceId: this.$route.query.camundaInstanceId,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node-two`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      return data.data || false;
    },
    async getLastNode() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        staffGuid: userinfo.staffGuid,
        deploymentId: this.$route.query.camundaDeploymentId,
        processInstanceId: this.$route.query.camundaInstanceId,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/is-last-node`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      this.isLastNode = data.data || false;
    },
    //判断是否最后一个人审批
    isLastPerson() {
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        staffGuid: userinfo.staffGuid,
        deploymentId: this.$route.query.camundaDeploymentId,
        processInstanceId: this.$route.query.camundaInstanceId,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let showPassForm = res.data.data || false;
          if(showPassForm == true){
            // self.$refs.pass.showForm = showPassForm;
            // self.$refs.pass.rowData = this.formData;
            // self.$refs.pass.showPass = true;
            self.$refs.stampAttachmentDialogRef.open(this.formData);
          }else{
            self.passDialogVisible = true;
          }
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取运营报告数据
    getOperationList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        flowType: '00016',
        bizGuids: this.formData.operationReportGuidList,
        isHedgeList:["Y","N"]
        // currentServiceTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.operationTableData = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //运营报告详情
    toOperationDetail(row){
      let query = {
        guid: row.guid,
        approveStaffGuid: row.approveGuid,
        camundaInstanceId: row.camundaInstanceId,
        camundaDeploymentId: row.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: row.staffGuid,
        submitStaffName: row.staffName,
        toType:2,
        productGuid:this.$route.query.productGuid
      };
      this.$router.push({
        path: '/upstreamOperationReportDetail',
        query,
      });
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/payment-ticket/detail?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData = res.data.data;
            self.getOperationList();
            self.getTypeBizList();
            self.getTitleBizList();
            console.log('self.formData.planInvoiceApplyList',self.formData);
            // self.formData.month = self.formData.month.substr(0,4) + '-' + self.formData.month.substr(4,2);
            self.formData.planRepayDate = self.$moment(self.formData.planRepayDate).format('YYYY-MM-DD');
            self.approveGuid = self.formData.approveVO && self.formData.approveVO.approveGuid;
            // 需开票信息
            if (self.formData.planInvoiceApplyList&&self.formData.planInvoiceApplyList.length > 0) {
              self.formData.planInvoiceApplyList.forEach((i) => {
                if(!i.invoiceDate){
                  i.label =
                '-' +
                  ' — ' +
                  this.formatMoney(i.invoiceAccount || 0) +
                  '元';
                }else{
                  i.label =
                
                  self.$moment(i.invoiceDate).format('YYYY-MM-DD') +
                  ' — ' +
                  this.formatMoney(i.invoiceAccount || 0) +
                  '元';
                }
                
              });
              console.log(111,self.formData.planInvoiceApplyList);
            }
            // 上游票据信息
            // if (self.formData.invoiceInfoVO) {
            //   let i = self.formData.planInvoiceApplyList
            //     if(!i.invoiceDate){
            //       i.label =
            //     '-' +
            //       ' — ' +
            //       this.formatMoney(i.invoiceAccount || 0) +
            //       '元';
            //     }else{
            //       i.label =
                
            //       self.$moment(i.invoiceDate).format('YYYY-MM-DD') +
            //       ' — ' +
            //       this.formatMoney(i.invoiceAccount || 0) +
            //       '元';
            //     }
                
              
            //   console.log(111,self.formData.planInvoiceApplyList);
            // }
            //财务信息（多选，遍历 invoiceInfoVOList 逐项拼 label）
            let voList = self.formData.invoiceInfoVOList || (self.formData.invoiceInfoVO ? [self.formData.invoiceInfoVO] : []);
            this.invoiceInfoVOList = voList.map(inv => {
              let label;
              if (!inv.invoiceDate) {
                label = '-' + ' — ' + this.formatMoney(inv.invoiceAccount || 0) + '元';
              } else {
                label = self.$moment(inv.invoiceDate).format('YYYY-MM-DD') + ' — ' + this.formatMoney(inv.invoiceAccount || 0) + '元';
              }
              return { ...inv, label };
            });
            // 兼容单值（部分旧逻辑仍读 invoiceInfoVO）
            this.invoiceInfoVO = this.invoiceInfoVOList.length ? this.invoiceInfoVOList[0] : (self.formData.invoiceInfoVO || {});
            // 开票信息
            if (self.formData.invoiceApplyVO) {
              this.invoiceApplyVO = self.formData.invoiceApplyVO;
            }
            //附件文件类型标记（多选，遍历每张发票的票据附件；盖章附件已单据级化，后端不再下发到发票VO）
            (this.invoiceInfoVOList || []).forEach(infoVO => {
              ['invoiceAttach'].forEach(key => {
                if (infoVO[key]) {
                  infoVO[key].forEach((i) => {
                    let fileSuffix = i.fileName ? i.fileName.substring(i.fileName.lastIndexOf('.') + 1) : '';
                    if (fileSuffix == 'pdf' || fileSuffix == 'PDF') {
                      i.type = 'pdf';
                    } else if (fileSuffix == 'xls' || fileSuffix == 'xlsx') {
                      i.type = 'excel';
                    } else if (fileSuffix == '.doc' || fileSuffix == '.docx') {
                      i.type = 'word';
                    } else if (fileSuffix == 'zip' || fileSuffix == 'rar') {
                      i.type = 'zip';
                    } else {
                      i.type = 'img';
                    }
                  });
                }
              });
            });
            self.tableData = self.formData.detailList;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取推广计划
    getPlanDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/payment-ticket/get-task-detail?guid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.planData = res.data.data;
            
            
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getBpmnUrl() {
      if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.$route.query.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.$route.query.camundaDeploymentId +
          '&token=' +
          localStorage.token;
        console.log(this.srcs);
      } else {
        this.iframeSh = false;
      }
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.approveGuid,
            flowType: self.flowType,
            approveStaffGuid: self.currentStaffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              // 最后一个节点 撤销  开票申请 为 是 跳转到 运营报告对冲
              if (self.isLastNode && self.formData.isApplyInvoice == "Y") {
                self.$router.push('/upstreamHedgingAdd')
                return
              }
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/upstreampaymentAdd',
        query: {
          // bizGuid: this.$route.query.bizGuid,
          guid: this.$route.query.guid,
          productGuid:this.$route.query.productGuid
        },
      });
    },
    //通过
    async toPass() {
      let self = this;
      self.approveSuggest = '';
      if (self.isThirdPartyContractor) {
        self.passDialogVisible = true;
        return;
      }
      // 开票申请 为 是
      if (self.formData.isApplyInvoice == "Y") {
        // 判断是否是倒数第二节点（财务票据上传）
        const isSecondLastNode = await self.isSecondLastNode();
        if (isSecondLastNode) {
          self.$refs.invoiceInfoDialogRef.open(self.formData);
          return;
        }
      }
      self.isLastPerson();
    },
    toReject() {
      let self = this;
      self.approveSuggest = '';
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('审批通过！');
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('驳回成功！');
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 预开票
    isInvoicedChange() {
      //  if(formData.isInvoiced == 'N'){
      this.formData.isApplyInvoice = 'N';
      this.formData.planInvoiceApplyGuidList = [];
      //  }
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    
  },
  computed: {
    /**
     * 票据信息展示列表：多类目批次发票的 票据附件/开票日期/税率 完全一致时整合为一条展示
     * （整合后不显示"发票(N)"标题），存在差异则逐张展示
     */
    invoiceDisplayList() {
      const list = this.invoiceInfoVOList || [];
      if (list.length <= 1) {
        return list;
      }
      // 比较本展示块实际渲染的三项内容（附件按文件名+路径逐一比对）
      const contentKey = (inv) => [
        inv.invoiceDate || '',
        inv.taxRate || '',
        (inv.invoiceAttach || []).map((f) => `${f.fileName || ''}|${f.path || ''}`).join(';')
      ].join('||');
      const firstKey = contentKey(list[0]);
      return list.every((inv) => contentKey(inv) === firstKey) ? [list[0]] : list;
    },
    /**是否是 三方接包服务商*/
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
    // 是否展示财务信息
    isShowFinanceInfo() {
      if (this.isThirdPartyContractor) {
        // 三方不展示
        return false;
      }
      const { invoiceInfoVOList, formData } = this;
      // 单据级盖章附件（不依赖发票，无关联发票的单也展示）
      if (formData.paymentAdviceAttach && formData.paymentAdviceAttach.length) {
        return true;
      }
      // 单据级物流（需邮寄，不依赖发票）
      if (formData.isMail == "Y" && (formData.expressNo || formData.expressCompany)) {
        return true;
      }
      // 有数据就展示（多选，任一张发票有数据即显示）
      if (!invoiceInfoVOList || !invoiceInfoVOList.length) {
        return false;
      }
      for (const inv of invoiceInfoVOList) {
        // 票据相关（需申请开票）
        if (formData.isApplyInvoice == "Y") {
          if ((inv.invoiceAttach && inv.invoiceAttach.length) || inv.invoiceDate || inv.taxRate) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 0 0 10px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 10px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  /* padding: 0 20px; */
  box-sizing: border-box;
}
.contract-apply-file .file-label {
  width: 100px;
  line-height: 30px;
  text-align: right;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.approve-img {
  position: absolute;
  top: 20%;
  right: 60px;
  width: 78px;
  height: 78px;
}
/* 合同信息 */
.contract-base-box .el-col-12,
.contract-base-box .el-col-24 {
  display: flex;
  line-height: 22px;
  margin-bottom: 10px;
}
.el-col-12:nth-child(2n + 1) .contract-base-title,
.el-col-24:nth-child(2n + 1) .contract-base-title {
  flex-shrink: 0;
  min-width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title,
.el-col-12:nth-child(2n) .contract-base-title {
  flex-shrink: 0;
  min-width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}

/* 付款通知书 */
table {
  /* border-color: #D9D9D9; */
  font-size: 12px;
  border-spacing: 0px;
  line-height: 30px;
  width: 100%;
  color: #212121;
  border: 1px solid #d9d9d9;
  border-top: none;
  border-left: none;
  text-align: left;
}
table tr td,
.tdBg {
  height: 32px;
  border: 1px solid #d9d9d9;
  border-bottom: none;
  border-right: none;
  padding: 0 6px;
}
.tBg {
  background: #e5e5e5;
}
.tdBg {
  background: #fafafa;
}
.tdCenter {
  text-align: center;
  border-right: none;
}
.pay-box h2 {
  font-size: 20px;
}
.pay-box p {
  text-align: left;
  color: #666666;
}
.pay-title-txt {
  display: flex;
  color: #666666;
  font-size: 14px;
  text-align: left;
}
.pay-title-txt span:first-child {
  margin-right: 150px;
}
.pay-write {
  text-align: right;
  padding: 90px 60px;
  box-sizing: border-box;
}
.look-detail {
  color: #4fa1a4;
  cursor: pointer;
}
.contract-apply-item span {
  color: #666666;
}
.input-box {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
.table-total-money{
  font-size:12px;
  border-top:none;
}
.invoicedFlex{
  display: flex;
  flex-direction: column;
}
.duichong-img{
  position:absolute;
  top:0;
  right:0;
  width:81px;
}
.page-write {
  text-align: left;
  display: flex;
  width: 100%;
  border: 1px solid #d9d9d9;
  /* padding: 90px 60px;
  box-sizing: border-box; */
  
}
.page-write div{
  flex: 1;
  padding:5px 60px  60px 5px;

}
.page-write div:first-child{
  border-right:1px solid #d9d9d9;
}
</style>
